import { useAppSelector } from "../../../Redux/hooks";
// import Exercise from "./Exercise/Exercise";
// import HealthData from "./HealthData/HealthData";
// import Learn from "./Learn/Learn";
import ParticipantProfile from "./ParticipantProfile";

const MenuItemSelector = () => {
  const type = useAppSelector((state) => state.participantTab.categoryType);

  switch (type) {
    case "patient_profile":
      return <ParticipantProfile />;
    // case "health_data":
    //   return <HealthData />;
    // case "exercises":
    //   return <Exercise />;
    // case "learn":
    //   return <Learn />;
    default:
      return null;
  }
};

export default MenuItemSelector;
